import { makeStyles } from 'tss-react/mui'
import { Box } from '@mui/material'
import React, { FC } from 'react'

const useStyles = makeStyles()(theme => ({
  container: {
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    top: theme.spacing(1),
    left: theme.spacing(4),
    right: theme.spacing(4),
    userSelect: 'none',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    pointerEvents: 'none',
    color: theme.shape.select.textColor,
    fontSize: theme.shape.inputField.fontSize,
  },
  error: {
    color: theme.palette.error.main,
  },
}))

interface PlaceholderProps {
  error?: boolean
  children?: React.ReactNode
}

/**
 * Placeholder text for the markdown editor
 */
export const Placeholder: FC<PlaceholderProps> = ({ children, error }) => {
  const { classes } = useStyles()
  return <Box className={error ? `${classes.container} ${classes.error}` : `${classes.container}`}>{children}</Box>
}
